<template>
<div>
  <!-- Products Modal -->
   <div class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel" v-if="showProductsModal">
    <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
      <h4 class="font-size-h4 font-weight-bold m-0">Products in Discount: {{ currentDiscount?.name }}</h4>
      <a href="javascript:void(0)" class="btn btn-sm btn-icon btn-light btn-hover-primary kt_notes_panel_close" v-on:click="showProductsModal = false">
        <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
        </svg>
      </a>
    </div>
    
    <div v-if="loadingProducts" class="text-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Product Name</th>
              <th>SKU</th>
              <th>Price</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in discountProducts" :key="product.id">
              <td>{{ product.id }}</td>
              <td>
                <router-link :to="'/admin/product/' + product.id" target="_blank">
                  {{ product.detail?.[0]?.title || product.name }}
                </router-link>
              </td>
              <td>{{ product.sku }}</td>
              <td>{{ formatCurrency(product.price) }}</td>
             
            </tr>
            <tr v-if="discountProducts.length === 0">
              <td colspan="5" class="text-center">No products found for this discount</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="d-flex flex-column-fluid">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-lg-12 col-xl-12">
              <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                <div class="card-header align-items-center border-bottom-dark px-0">
                  <div class="card-title mb-0">
                    <h3 class="card-label mb-0 font-weight-bold text-body">
                      Discount List
                    </h3>
                  </div>
                  <div class="icons d-flex">
                    <router-link to="/admin/add-discount" class="btn ml-2 p-0 kt_notes_panel_toggle" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" v-if="$parent.permissions.includes('add-discount')">
                      <span class="bg-secondary h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle shadow-sm">
                        <svg width="25px" height="25px" viewBox="0 0 16 16" class="bi bi-plus white" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                        </svg>
                      </span>
                    </router-link>
                    <button @click="bulkDelete" class="btn btn-danger ml-2" v-if="selectedDiscounts.length > 0">
                      Delete Selected ({{ selectedDiscounts.length }})
                    </button>
                    <router-link to="/admin/add-discount" class="btn btn-primary ml-2" v-if="$parent.permissions.includes('discount-manage')">
                      <i class="fas fa-plus"></i> Add Discount
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card card-custom gutter-b bg-white border-0">
                <div class="card-body">
                  <div class="table-responsive" id="printableTable">
                    <div id="discount_wrapper" class="dataTables_wrapper no-footer">
                      <div class="dataTables_length" id="discount_length">
                        <label>Show 
                        <select name="discount_length" class="" v-model="limit" v-on:change="fetchDiscounts()">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select> entries</label>
                      </div>

                      <div id="discount_filter" class="dataTables_filter">
                        <label>Search:<input type="text" class="" placeholder="" v-model="searchParameter" @keyup="fetchDiscounts()"></label>
                        <button v-if="this.searchParameter != ''" @click="clearSearch">clear</button>
                      </div>
                      
                      <table id="discount" class="display dataTable no-footer">
                        <thead class="text-body">
                          <tr>
                            <th width="30">
                              <input type="checkbox" v-model="selectAll" @change="toggleSelectAll">
                            </th>
                            <th @click="sorting('id')" 
                                :class="(sortType == 'asc' || sortType == 'ASC') && sortBy == 'id' ? 'sorting_asc' : 
                                       (sortType == 'desc' || sortType == 'DESC') && sortBy == 'id' ? 'sorting_desc' : 'sorting'">
                              ID
                            </th>
                            <th @click="sorting('name')" 
                                :class="(sortType == 'asc' || sortType == 'ASC') && sortBy == 'name' ? 'sorting_asc' : 
                                       (sortType == 'desc' || sortType == 'DESC') && sortBy == 'name' ? 'sorting_desc' : 'sorting'">
                              Name
                            </th>
                            <th @click="sorting('product_id')" 
                                :class="(sortType == 'asc' || sortType == 'ASC') && sortBy == 'product_id' ? 'sorting_asc' : 
                                       (sortType == 'desc' || sortType == 'DESC') && sortBy == 'product_id' ? 'sorting_desc' : 'sorting'">
                              Product
                            </th>
                            <th @click="sorting('amount')" 
                                :class="(sortType == 'asc' || sortType == 'ASC') && sortBy == 'amount' ? 'sorting_asc' : 
                                       (sortType == 'desc' || sortType == 'DESC') && sortBy == 'amount' ? 'sorting_desc' : 'sorting'">
                              Fixed Amount
                            </th>
                            <th @click="sorting('percentage')" 
                                :class="(sortType == 'asc' || sortType == 'ASC') && sortBy == 'percentage' ? 'sorting_asc' : 
                                       (sortType == 'desc' || sortType == 'DESC') && sortBy == 'percentage' ? 'sorting_desc' : 'sorting'">
                              Percentage
                            </th>
                            <th @click="sorting('start_date')" 
                                :class="(sortType == 'asc' || sortType == 'ASC') && sortBy == 'start_date' ? 'sorting_asc' : 
                                       (sortType == 'desc' || sortType == 'DESC') && sortBy == 'start_date' ? 'sorting_desc' : 'sorting'">
                              Start Date
                            </th>
                            <th @click="sorting('end_date')" 
                                :class="(sortType == 'asc' || sortType == 'ASC') && sortBy == 'end_date' ? 'sorting_asc' : 
                                       (sortType == 'desc' || sortType == 'DESC') && sortBy == 'end_date' ? 'sorting_desc' : 'sorting'">
                              End Date
                            </th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody class="kt-table-tbody text-dark">
                          <tr class="kt-table-row kt-table-row-level-0" v-for="discount in discounts" :key="discount.id">
                            <td>
                              <input type="checkbox" v-model="selectedDiscounts" :value="discount.id">
                            </td>
                            <td>{{ discount.id }}</td>
                            <td>{{ discount.name }}</td>
                            <td>
                              <span v-if="discount.is_global">Global Discount</span>
                              <span v-else>
                                {{ discount.products_count || 0 }} Products
                                <button @click="viewProducts(discount)" class="btn btn-link p-0 ml-1">
                                  <i class="fa fa-eye text-info"></i>
                                </button>
                              </span>
                            </td>
                            <td>{{ discount.amount ? formatCurrency(discount.amount) : '-' }}</td>
                            <td>{{ discount.percentage ? discount.percentage + '%' : '-' }}</td>
                            <td>{{ formatDate(discount.start_date) }}</td>
                            <td>{{ formatDate(discount.end_date) }}</td>
                            <td>
                              <span :class="getStatusClass(discount)">
                                {{ getStatusText(discount) }}
                              </span>
                            </td>
                            <td>
                              <button @click="viewProducts(discount)" class="btn btn-sm btn-icon btn-light btn-hover-info mr-1">
                                <i class="fa fa-eye"></i>
                              </button>
                                <button @click="deleteDiscount(discount.id)" class="btn btn-sm btn-icon btn-light btn-hover-danger">
                                <i class="fa fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <ul class="pagination pagination-sm m-0 float-right">
                        <li :class="{disabled: !pagination.prev_page_url}">
                          <button class="page-link" @click="fetchDiscounts(pagination.prev_page_url)">Previous</button>
                        </li>
                        <li class="disabled">
                          <button class="page-link text-dark">Page {{ pagination.current_page }} of {{ pagination.last_page }}</button>
                        </li>
                        <li :class="{disabled: !pagination.next_page_url}" class="page-item">
                          <button class="page-link" @click="fetchDiscounts(pagination.next_page_url)">Next</button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";
import $ from 'jquery';

export default {
  data() {
    return {
      display_form: 0,
      discounts: [],
      selectedDiscounts: [],
      selectAll: false,
      searchParameter: '',
      sortBy: 'id',
      sortType: 'DESC',
      limit: 10,
      pagination: {},
      errors: new ErrorHandling(),
      token: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      },
      // Modal related data
    
        showProductsModal: false, // Add this for the offcanvas modal
      discountProducts: [],
      loadingProducts: false,
      currentDiscount: null
    };
  },

  methods: {
    fetchDiscounts(page_url) {
      this.$parent.loading = true;
      page_url = page_url || "/api/admin/discounts";
      
      let params = {
        limit: this.limit,
        searchParameter: this.searchParameter,
        sortBy: this.sortBy,
        sortType: this.sortType,
        with: 'products_count'
      };

      axios.get(page_url, { params, headers: this.token.headers })
        .then(response => {
          this.discounts = response.data.data;
          this.makePagination(response.data.meta, response.data.links);
          this.selectedDiscounts = [];
          this.selectAll = false;
        })
        .catch(error => {
          console.error("Error fetching discounts:", error);
        })
        .finally(() => {
          this.$parent.loading = false;
        });
    },

   
 viewProducts(discount) {
      this.currentDiscount = discount;
      this.loadingProducts = true;
      this.discountProducts = [];
      this.showProductsModal = true;
      
      axios.get(`/api/admin/discounts/${discount.id}/products`, this.token)
        .then(response => {
          this.discountProducts = response.data.data;
        })
        .catch(error => {
          console.error("Error fetching discount products:", error);
          this.$toaster.error('Failed to load products');
        })
        .finally(() => {
          this.loadingProducts = false;
        });
    },
    makePagination(meta, links) {
      this.pagination = {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev
      };
    },

    formatCurrency(value) {
      return '$' + parseFloat(value).toFixed(2);
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString();
    },

    getStatusClass(discount) {
      const now = new Date();
      const start = new Date(discount.start_date);
      const end = new Date(discount.end_date);
      
      if (now < start) return 'badge badge-info';
      if (now > end) return 'badge badge-danger';
      return 'badge badge-success';
    },

    getStatusText(discount) {
      const now = new Date();
      const start = new Date(discount.start_date);
      const end = new Date(discount.end_date);
      
      if (now < start) return 'Upcoming';
      if (now > end) return 'Expired';
      return 'Active';
    },

   deleteDiscount(id) {
      if (confirm('Are you sure you want to delete this discount? This will remove the discount from all associated products.')) {
        this.$parent.loading = true;
        
        axios.delete(`/api/admin/discounts/${id}`, this.token)
          .then(() => {
            this.fetchDiscounts();
            this.$toaster.success('Discount deleted successfully');
          })
          .catch(error => {
            console.error("Error deleting discount:", error);
            this.$toaster.error(error.response?.data?.message || 'Failed to delete discount');
          })
          .finally(() => {
            this.$parent.loading = false;
          });
      }
    },

    bulkDelete() {
      if (this.selectedDiscounts.length === 0) return;
      
      if (confirm(`Are you sure you want to delete ${this.selectedDiscounts.length} selected discounts?`)) {
        axios.post('/api/admin/discounts/bulk-delete', { 
          ids: this.selectedDiscounts 
        }, this.token)
        .then(() => {
          this.fetchDiscounts();
          toastr.success('Selected discounts deleted successfully');
          this.selectedDiscounts = [];
          this.selectAll = false;
        })
        .catch(error => {
          console.error("Error deleting discounts:", error);
          toastr.error('Failed to delete selected discounts');
        });
      }
    },

    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedDiscounts = this.discounts.map(discount => discount.id);
      } else {
        this.selectedDiscounts = [];
      }
    },

    sorting(sortBy) {
      this.sortBy = sortBy;
      this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
      this.fetchDiscounts();
    },

    clearSearch() {
      this.searchParameter = "";
      this.fetchDiscounts();
    }
  },

  mounted() {
    this.fetchDiscounts();
  },

  props: ['loading'],
};
</script>

<style scoped>

.offcanvas.offcanvas-right {
  right: 0px;
  left: auto;
}
.badge {
  padding: 5px 10px;
  border-radius: 3px;
  font-size: 12px;
}
.badge-info {
  background-color: #17a2b8;
  color: white;
}
.badge-success {
  background-color: #28a745;
  color: white;
}
.badge-danger {
  background-color: #dc3545;
  color: white;
}
.badge-primary {
  background-color: #007bff;
  color: white;
}
</style>